export default __webpack_public_path__ + "static/media/StevenPortfolio.6b5262f7.webp";